import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';

const CustomModal = ({ className, ...rest }) =>
  <Modal className={className} {...rest} />;

CustomModal.propTypes = {
  className: PropTypes.string.isRequired,
};

export default styled(CustomModal)`
  color: ${p => p.theme.colors.text};

  .ant-modal-content {
    padding: 0;
    background-color: transparent;
  }
  .ant-modal-header {
    padding: 15px 24px;
    margin: 0;
    background-color: ${p => p.theme.colors.themeSecondary};
    border-color: ${p => p.theme.colors.themeSecondary};

    .ant-modal-title { color: #fff; }
  }
  .ant-modal-body {
    padding: 20px 24px;
    background-color: #fff;
  }
  .ant-modal-close { color: #fff; }
`;
